import {
    SET_TITLE
} from './TitleType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_TITLE) {
        return {
            ...state,
            titleDropDownList: action.titleDropDownList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}